module.exports = __webpack_public_path__ + "static/media/2025-The-Debrief-Feature-Banner-sm@2x.af44d012.jpg";